import React from 'react';

const Experience = () => null;

export default Experience;
